module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAaBAMAAACa4xtRAAAAG1BMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZkDdeV8AAAACHRSTlMA2hoRz8oE46jgCmUAAAA4SURBVAjXY2BLYICAdCcog6VRAcJg9hCCCpkQJWQKF4rAK5QAZyCkEIoxBRBWmOAXQDge4R24BwFl2hAj/G1LHgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/forward.png
// module id = OA1H
// module chunks = 0